import { useCallback, useRef, useState } from 'react';

export function useIntersectionObserver(options?: IntersectionObserverInit) {
  const [isIntersecting, setIsIntersecting] = useState(false);
  const observerRef = useRef<IntersectionObserver | null>(null);
  const optionsRef = useRef(options);
  optionsRef.current = options;

  const ref = useCallback((node: HTMLDivElement | null) => {
    if (observerRef.current) {
      observerRef.current.disconnect();
      observerRef.current = null;
    }
    if (node) {
      observerRef.current = new IntersectionObserver(
        ([entry]) => setIsIntersecting(entry?.isIntersecting ?? false),
        optionsRef.current
      );
      observerRef.current.observe(node);
    }
  }, []);

  return { ref, isIntersecting };
}
